import React, { Component } from "react";
import { AdminHeader } from "./header/admin-header.component";
import './dashboard.css'
import { CalendarScheduler } from "../Invoice/invoice-calendar/calendar.component";
import WhatsHappening from "./whatshappening/whats-happening.component";
import SummaryDetails from "./user-summary/user-summary-component";
import AdminBarGraph from "./graph/dashboard-bar-graph.component";
import AdminHorizontalGraph from "./graph/dashboard-horizontal-graph.component";
import QuickLinks from "./quick-links/quick-links.component";
export class AdminDashboard extends Component {
    
    render(){

        const filterData = [
            {
                id:1,
                filterTitle:"Item 1",               
            },
            {
                id:2,
                filterTitle:"Item 2",              
            },
            {
                id:3,
                filterTitle:"Item 3",              
            }, {       
                id:4,        
                filterTitle:"Item 4 with Checkbox",              
            }
        ]

        const data = [
            { name: 'Jan', Pending: 2400, Approved: 1800, Rejected: 600, amt: 2400 },
            { name: 'Feb', Pending: 1398, Approved: 2100, Rejected: 702, amt: 2210 },
            { name: 'Mar', Pending: 9800, Approved: 2900, Rejected: 6900, amt: 2290 },
            { name: 'Apr', Pending: 3908, Approved: 2000, Rejected: 1908, amt: 2000 },
            { name: 'May', Pending: 4800, Approved: 2181, Rejected: 2619, amt: 2181 },
            { name: 'Jun', Pending: 3800, Approved: 2500, Rejected: 1300, amt: 2500 },
            { name: 'Jul', Pending: 4300, Approved: 2100, Rejected: 2200, amt: 2100 },
          ];

          const PARledger= [ 
            {name: 'Pending', color:'#d5002f'},
            {name: 'Approved', color:'#ffc82c'},
            {name: 'Rejected', color:'#008eff'}          
        ];

       const horizontalCharts = [
            { name: "United States of America", value:71957.54},
            { name: "United States of America", value:32174.37},
            { name: "Romania", value:34166.84},
            { name: "United States of America", value:0},
            { name: "United States of America", value:0}
        ];

        const filtersub=[
            {key:31, value:"Change Location Address"},
            {key:5,value:"Change Price Plan"},
            {key:4,value:"Change User"},
            {key:14,value:"Change Vendor"},
            {key:29,value:"Change Vendor"},
            {key:27,value:"New Circuit"},
            {key:9,value:"New Mobile Subscription"},
            {key:32,value:"Other"}];

        const quickLinks=[
           {
            label:"Manage User",
            href: "#"
           },
           {
            label:"Manage Vendor",
            href: "#"
           },
           {
            label:"Cost Code",
            href: "#"
           },
           {
            label:"Frequently Ask Question",
            href: "#"
           },
           {
            label:"Link 1",
            href: "#"
           }
        ]
      
        const happening=[
            {
                title:"Orange to lunch experimental",
                date:"July 30, 2021",
                type:"Reminder"
            },
            {
                title:"Ticket Request 7654321 has been added",
                date:"July 30, 2021",
                type:"Survey"
            }
        ]
        return(
            <>
                <div className="admin-dashboard-wrapper">
                    <AdminHeader title="Admin Dashboard" username="Joe Doe Smith" badge="Administrator" firstname="John"
                        message="Get familiar dashboard, here are some ways to get you started."
                    />
                    <div className="admin-container">
                        <div className="admin-calendar-container">
                            <CalendarScheduler />
                        </div>
                        <div className="whats-happening-container">
                            <WhatsHappening listData={happening} filterData={filterData} filtersub={filtersub}/>
                        </div>
                    </div>
                </div>
                <div>
                    <SummaryDetails />
                </div>
                <div>
                   <AdminBarGraph title="Invoice Trend" data={data} ledger={PARledger}/>
                   <AdminHorizontalGraph title="Inventory Per Category" horizontalChart={horizontalCharts} />
                </div>
                <div>
                    <QuickLinks title="Quick Links" links={quickLinks} />
                </div>

            </>
        )
    }
}